import { IconChevronRight16 } from '@warp-ds/icons/react';
import cn from 'classnames';

import type { ReactNode } from 'react';

import { replaceDashWithComma } from '../../../../util/formatting';

import type { AutocompleteOption, AutocompleteProps } from '../../../types';

import styles from '../Autocomplete.module.css';

interface AutocompleteOptionItemProps {
    option: AutocompleteOption;
    index: number;
    id: string;
    selected: number;
    vertical: AutocompleteProps['vertical'];
    departure?: boolean;
    onClick: () => void;
    onHover: () => void;
    icon: ReactNode | null;
    defaultView?: boolean;
    shouldShowCount?: boolean;
}

export const AutocompleteOptionItem = ({
    option,
    index,
    id,
    selected,
    vertical,
    onClick,
    onHover,
    icon,
    defaultView = false,
    shouldShowCount = true,
}: AutocompleteOptionItemProps) => (
    <li
        id={`${id}-option-${index}`}
        // biome-ignore lint/a11y/noNoninteractiveElementToInteractiveRole: <li> is given role="option" as required by the ARIA listbox pattern
        role="option"
        aria-selected={selected === index}
        data-testid={`${id}-option-${index}`}
        onClick={onClick}
        onMouseOver={onHover}
        tabIndex={-1}
        className={cn(styles['autocomplete-option-item'], 'flex flex-row items-center cursor-pointer gap-8', {
            's-bg-primary-subtle': selected === index,
            'flex-row justify-between': vertical === 'fhh',
        })}>
        {icon}
        <span title={option.text} className={styles['autocomplete-option-item__text']}>
            {replaceDashWithComma(option.text)}
        </span>
        {shouldShowCount && option.count && <span className="font-bold">{option.count}</span>}
        {defaultView && <IconChevronRight16 aria-hidden focusable="false" />}
    </li>
);
